var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 13,
    viewBox: "0 0 21 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#117BBC",
    d: "M0 12.67h20.684V.1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M19.977.806h-2.349l-5.426 3.128V.806H8.481v3.14L3.035.806H.707v1.356l4.07 2.362H.707v3.721h4.07l-4.07 2.363v1.356h2.328l5.446-3.14v3.14h3.721V8.835l5.426 3.13h2.35v-1.357l-4.091-2.363h4.09v-3.72h-4.09l4.09-2.363z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB2626",
    d: "M7.151 4.527L.706.806v.888l4.892 2.833zM19.977.806h-1.515l-6.26 3.72h1.54zM.707 11.964h1.539L8.48 8.245h-1.54zM13.563 8.245l6.414 3.72v-.887L15.11 8.245z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB2626",
    d: "M11.431.806H9.252v4.49H.707v2.18h8.545v4.488h2.18V7.475h8.545V5.296h-8.546z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.9a0f3da32ea26801d9cdfbb052fba001.svg";
export { ForwardRef as ReactComponent };